import { StudentCourseModel } from '../student-course.model';

export class StudentCurrentCourseModel extends StudentCourseModel {}

export function StudentCurrentCourseModel_ClassTransform_Type() {
	return StudentCurrentCourseModel;
}
